module.exports = __webpack_public_path__ + "img/bien.5691ceed.svg";